import { render, staticRenderFns } from "./ProviderOrderListPage.vue?vue&type=template&id=24c93944&scoped=true&"
import script from "./ProviderOrderListPage.vue?vue&type=script&lang=js&"
export * from "./ProviderOrderListPage.vue?vue&type=script&lang=js&"
import style0 from "./ProviderOrderListPage.vue?vue&type=style&index=0&id=24c93944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c93944",
  null
  
)

export default component.exports